export const GOOGLE_ADS_ID = 'AW-17728981557';
export const GA4_ID = 'G-679J8CY326';

// Optional Google Ads conversion label (e.g. 'AW-17728981557/XXXXXXXXX')
// If empty, events are sent to the default account ID: AW-17728981557
export const GOOGLE_ADS_CONVERSION_LABEL = '';

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

/**
 * Ensures gtag is initialized and configured for Google Ads and Google Analytics
 */
export function loadGtag() {
  if (typeof window === 'undefined') return;

  try {
    window.dataLayer = window.dataLayer || [];

    if (typeof window.gtag !== 'function') {
      window.gtag = function (...args: unknown[]) {
        try {
          (window.dataLayer as unknown[]).push(args);
        } catch {
          // ignore
        }
      };
    }

    // Configure both Google Ads and Google Analytics 4
    window.gtag('config', GOOGLE_ADS_ID);
    window.gtag('config', GA4_ID);

    // If gtag.js script is not already injected, add it
    if (!document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
      const s = document.createElement('script');
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}`;
      document.head.appendChild(s);

      s.onload = () => {
        try {
          window.gtag?.('js', new Date());
          window.gtag?.('config', GOOGLE_ADS_ID);
          window.gtag?.('config', GA4_ID);
        } catch {
          // ignore
        }
      };
    }
  } catch {
    // ignore
  }
}

export interface ConversionOptions {
  sendTo?: string;
  value?: number;
  currency?: string;
  transactionId?: string;
  [key: string]: unknown;
}

/**
 * Dispatches a conversion event to Google Ads and GA4
 */
export function trackConversion(eventName: string, options: ConversionOptions = {}) {
  if (typeof window === 'undefined') return;

  try {
    // Ensure gtag proxy is available
    window.dataLayer = window.dataLayer || [];
    if (typeof window.gtag !== 'function') {
      window.gtag = function (...args: unknown[]) {
        try {
          (window.dataLayer as unknown[]).push(args);
        } catch {
          // ignore
        }
      };
    }

    const sendTo = options.sendTo || (GOOGLE_ADS_CONVERSION_LABEL ? `${GOOGLE_ADS_ID}/${GOOGLE_ADS_CONVERSION_LABEL}` : GOOGLE_ADS_ID);
    const value = options.value ?? 1.0;
    const currency = options.currency ?? 'SAR';

    // 1. Google Ads conversion event
    window.gtag('event', 'conversion', {
      send_to: sendTo,
      value,
      currency,
      transaction_id: options.transactionId,
      ...options,
    });

    // 2. Google Analytics 4 event
    window.gtag('event', eventName, {
      event_category: 'Conversion',
      event_label: typeof options.event_label === 'string' ? options.event_label : eventName,
      value,
      currency,
      ...options,
    });
  } catch (err) {
    console.warn('[Analytics] Conversion tracking error', err);
  }
}

/**
 * Tracks lead generation (Contact Form / Price Quote request)
 */
export function trackFormSubmission(data?: { name?: string; phone?: string; formName?: string }) {
  trackConversion('generate_lead', {
    event_category: 'Lead',
    event_label: 'طلب عرض سعر / تواصل',
    form_name: data?.formName || 'contact_form',
  });
}

/**
 * Tracks WhatsApp conversation start
 */
export function trackWhatsAppClick(location: string = 'general') {
  trackConversion('contact', {
    event_category: 'Lead',
    event_label: `WhatsApp - ${location}`,
    method: 'WhatsApp',
  });
}

/**
 * Tracks direct phone calls
 */
export function trackPhoneCall(location: string = 'general') {
  trackConversion('contact', {
    event_category: 'Lead',
    event_label: `Phone Call - ${location}`,
    method: 'Phone',
  });
}

export function loadVercelAnalytics() {
  return;
}

export default loadGtag;
